import { APIClient } from "./axiosClient";

export class ProductApi {
  static fetchGiftCardProducts(payload = {
    productName: null,
    productCode: null,
    redemptionMerchantId: null,
    brandId: null,
    countryId: null,
    platformCategoryId: null,
    programCategoryId: null,
    productType: "GIFT_CARD",
    pageNumber: 0,
    pageSize: 5,
    sortOrder: "desc",
    sortBy: "createdDate"
  }) {
    return APIClient(
      "/product/getGiftCardProducts",
      payload,
      { requestType: "post" }
    );
  }

  static fetchMerchandiseProducts(payload = {
    productName: null,
    productCode: null,
    redemptionMerchantId: null,
    brandId: null,
    countryId: null,
    platformCategoryId: null,
    productType: "MERCHANDISE",
    pageNumber: 0,
    pageSize: 5,
    sortOrder: "desc",
    sortBy: "createdDate"
  }) {
    return APIClient(
      "/product/getGiftCardProducts",
      payload,
      { requestType: "post" }
    );
  }

  static fetchFlightBookingProducts(payload = {
    productName: null,
    productCode: null,
    redemptionMerchantId: null,
    brandId: null,
    countryId: null,
    platformCategoryId: null,
    productType: "FLIGHT_BOOKING",
    pageNumber: 0,
    pageSize: 5,
    sortOrder: "desc",
    sortBy: "createdDate"
  }) {
    return APIClient(
      "/product/getGiftCardProducts",
      payload,
      { requestType: "post" }
    );
  }

  static fetchHotelBookingProducts(payload = {
    productName: null,
    productCode: null,
    redemptionMerchantId: null,
    brandId: null,
    countryId: null,
    platformCategoryId: null,
    productType: "HOTEL_BOOKING",
    pageNumber: 0,
    pageSize: 5,
    sortOrder: "desc",
    sortBy: "createdDate"
  }) {
    return APIClient(
      "/product/getGiftCardProducts",
      payload,
      { requestType: "post" }
    );
  }
} 